import React from 'react';
interface SectionHeadingProps {
  id: string;
  eyebrow?: string;
  title: React.ReactNode;
  body?: React.ReactNode;
  className?: string;
}
export function SectionHeading({
  id,
  eyebrow,
  title,
  body,
  className = ''
}: SectionHeadingProps) {
  return <div className={`mx-auto max-w-2xl text-center ${className}`} data-id="element-133" data-mp="jxqvc0p3mjep">
      {eyebrow && <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-134" data-mp="f3mmtd06q3bi">{eyebrow}</p>}
      <h2 id={id} className={`${eyebrow ? 'mt-4' : ''} font-display text-[2.1rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.75rem]`} data-id="element-135" data-mp="tvn62re4jcca">
        {title}
      </h2>
      {body && <p className="mt-5 text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-136" data-mp="ysx1qos3wk8k">{body}</p>}
    </div>;
}

/** Violet italic emphasis inside a display heading. */
export function Accent({
  children
}: {
  children: React.ReactNode;
}) {
  return <em className="font-display font-semibold italic text-brand-plum" data-id="element-137" data-mp="30ll83701rnsk">{children}</em>;
}